<!-- Content -->
@if ((nodeSharedFacade.currentSelectedElearningNode$ | async); as node) {
  <div class="mdsf-container js-modal-content-container"
    >
    @if ((appSharedFacade.page$(node.page) | async); as page) {
      <div class="mdsf-subject-container align-items-center scrollable m-0 p-0 w-100 flex-grow-1"
        >
        <medsurf-carousel></medsurf-carousel>
        <div class="mdsf-elearning">
          <medsurf-listnav [node]="node"
            [page]="page"
            [locked]="(appSharedFacade.canReadNode$(node?.id) | async) === false"
            [mainHeading]="true"
            [showSubjects]="true">
          </medsurf-listnav>
        </div>
      </div>
    }
    <medsurf-footer class="d-none d-md-inline"
      [links]="footerLinks"
      align="center">
    </medsurf-footer>
  </div>
}
